import { lazy } from "react";

const BlogListPage = lazy(() => import("./main"));
const CreateBlogPage = lazy(() => import("./create"));
const UpdateBlogPage = lazy(() => import("./update"));

export {
  BlogListPage, CreateBlogPage, UpdateBlogPage,
};
